import React, { useState } from "react"
import Image from "next/legacy/image"

import styles from './ListItemAddonsCalendarTicket.module.scss'

import { CartContext } from '../../../contexts/CartContext'

import { CartQuantityPicker } from '../../Cart/CartQuantityPicker/CartQuantityPicker'
import { ProductTicketType, ProductType } from '../../../types/ProductType'
import { AddToCartTicketType } from '../../../types/CartType'
import { CalendarTicketPopup } from './CalendarTicketPopup/CalendarTicketPopup'

import { formatPrice, getFromPrice } from '../../../utils/pricingUtils'
import { BookingSiteOperated } from "../../Misc/BookingSiteOperated/BookingSiteOperated";

type ListItemAddonsCalendarTicketProps = {
  product: ProductType,
}

export function ListItemAddonsCalendarTicket({ product }: ListItemAddonsCalendarTicketProps ) {
  const [qty, setQty] = useState(0)
  const [popupOpen, setPopupOpen] = useState(false);

  const ticket: ProductTicketType | undefined = product.tickets.length ? product.tickets[0] : undefined

  return (
    <CartContext.Consumer>
      {({cartAPI, cart}) => {

        const addToBasketBtn = (dateId: string, callback?: Function) => {
          return (
            <button
              className={styles.btn}
              disabled={ ( qty < 1 ) || cart?.loading }
              onClick={async () => {
                const items: Array<AddToCartTicketType> = []
                if (ticket) items.push({ ticketId: ticket.ticket_id, qty: qty, dateId })
                if (items.length) await cartAPI?.add(items)
                if (callback) callback()
                setQty(0)
              }}
            >ADD TO BASKET</button>
          )
        }

        const qtyPickerCalendar = ticket ? <CartQuantityPicker ticketPrice={ticket.price_from} showTicketPrice={false} showTotalPrice={false} qty={qty} setQty={setQty} loading={cart?.loading ?? false} leftText="All ages" leftSubText="" /> : null

        return (
          <div className={ `${styles.listItemCalendarTicket} ${ (product.internal.persuasion_ribbon || getFromPrice(product) == 0) ? styles.hasPersuasion : null }`}>
              {/* show persuasion ribbon if present, else show 'Coming soon' if from price is 0 */}
              { product.internal.persuasion_ribbon ? <div className={ styles.persuasionRibbon }>{ product.internal.persuasion_ribbon }</div> : getFromPrice(product) == 0 ? <div className={ styles.persuasionRibbon }>Coming soon</div> : null }
              <div className={ styles.product }>
                <div className={ styles.productImage }><Image priority src={product.img_sml} alt={product.title} width={400} height={270} layout='responsive'/></div>
                <div className={ styles.productDetails }>
                  <h3>{ product.title }</h3>
                  <p className={ styles.descriptionText }>{ product.desc_short }</p>
                  { product.internal.persuasion_ribbon ? <p className={ styles.persuasionText }>{ product.internal.persuasion_message }</p> : null }
                  <div className={ styles.productPricing }>
                {/* don't show from price unless it's more than 0 */}
                { getFromPrice(product) > 0 ? <>Starting from
                  <div className={ styles.fromPrice }>
                    £{ formatPrice(getFromPrice(product)) } pp
                  </div></> : null }
                </div>
                </div>
              </div>
            <div className={ styles.footer }>
              <div className={styles.footerDetails}>
              { getFromPrice(product) > 0 ? <><CalendarTicketPopup popupOpen={popupOpen} onClose={() => setPopupOpen(false)} product={product} qtyPicker={qtyPickerCalendar} addToBasketBtn={addToBasketBtn} />
                <p className={styles.detailsLink}><a className={styles.modalLink} onClick={() => setPopupOpen(true)}>View Details</a></p>
                <div className={styles.button}><button className={styles.btn} onClick={() => setPopupOpen(true)}>Select</button></div></> : null }
              </div>
              <BookingSiteOperated placement="ticket" />
            </div>
          </div>
        )
      }}
    </CartContext.Consumer>
  )
}
